module.exports = __webpack_public_path__ + "img/7.04496d7f.png";